import { React, useEffect, useRef, useState } from "react";
import { NavbarWrapper, SearchButton } from "./AdminDashboardLayout.styled";
import { Avatar, Backdrop } from "@mui/material";
import { AiOutlineUser } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import avatarIcon from "../assets/avatar.png";
import { FiChevronDown } from "react-icons/fi";
import searchIcon from "../assets/icons/searchIcon.svg";
// import notificationsIcon from "../assets/icons/notificationsIcon.svg";
// import messageIcon from "../assets/icons/NavMessageIcon.svg";
import logOutIcon from "../assets/icons/Logout.svg";
import { useDispatch } from "react-redux";
import { setParameters } from "../screens/parameters/ParameterSlice";

/* eslint-disable react/prop-types */
function Navbar({ data, setData, defaultData, logOutFunc }) {
	const dispatch = useDispatch();
	const [showDropdown, setShowDropdown] = useState(false);

	const InputRef = useRef(null);
	function focusInput() {
		InputRef.current.focus();
	}

	useEffect(() => {
		InputRef.current.value = ""; // Reset input value
		// handleChange({ target: { value: InputRef.current.value } }); // Search for query
	}, [defaultData]);

	const handleChange = (e) => {
		const query = e.target.value.toLowerCase();
		const currentPage = location.pathname.split("/")[1];
		if (data) {
			if (["parameters", "logistics", "lease", "apprenticeship", "travel-advance"].includes(currentPage)) {
				SearchFunction(query, currentPage);
			} else {
				SearchFunctionALT(query);
			}
		}
	};

	const SearchFunction = (query, currentPage) => {
		console.log(currentPage, query, data, defaultData);

		if (currentPage === "parameters") {
			const filteredData = defaultData?.filter((item) => item?.parameter?.toLowerCase().includes(query));
			dispatch(setParameters(filteredData));
			if (!query) dispatch(setParameters(defaultData)); // Reset data state
			console.log(defaultData);
		} else {
			const filteredData = defaultData.filter(
				(item) =>
					item?.productId?.productName?.toLowerCase().includes(query) ||
					item?.businessType?.toLowerCase().includes(query) ||
					item?.userId?.firstName?.toLowerCase().includes(query) ||
					item?.userId?.lastName?.toLowerCase().includes(query) ||
					item?.userId?.email?.toLowerCase().includes(query) ||
					item?.user?.firstName?.toLowerCase().includes(query) ||
					item?.user?.lastName?.toLowerCase().includes(query) ||
					item?.user?.email?.toLowerCase().includes(query) ||
					item?.businessId?.businessInterest?.toLowerCase().includes(query) ||
					item?.savingsType?.toLowerCase().includes(query) ||
					item?.objectId?.toLowerCase().includes(query)
			);
			setData(filteredData);
			if (!query) setData(defaultData); // Reset data state
		}
	};

	const SearchFunctionALT = (query) => {
		if (data) {
			// setData(defaultData)
			if (!query) {
				setData(defaultData);
				return;
			} else {
				const filteredData = defaultData.filter(
					(product) =>
						product.productName?.toLowerCase().includes(query) ||
						product.asset?.toLowerCase().includes(query) ||
						product.firstName?.toLowerCase().includes(query) ||
						product?.lastName?.toLowerCase().includes(query) ||
						product?.email?.toLowerCase().includes(query)
				);
				setData(filteredData);
			}
		}
	};

	return (
		<NavbarWrapper>
			<div className='searchbar-wrapper'>
				<input
					onChange={handleChange}
					ref={InputRef}
					type='text'
					placeholder='Search here ...'
					name='search'
				/>

				<SearchButton onClick={focusInput}>
					<img src={searchIcon} alt='search icon' />
					<p>Search</p>
				</SearchButton>
			</div>

			<section className='notifications_wrapper'>
				{/* <img src={notificationsIcon} style={{ height: "30px", width: "30px" }} alt='notification icon' />

				<img src={messageIcon} style={{ height: "30px", width: "30px" }} alt='message icon' /> */}

				<div className='profile_wrapper' onClick={() => setShowDropdown(!showDropdown)}>
					<Avatar
						src={avatarIcon}
						sx={{ width: { xs: "33px", sm: "37px" }, height: { xs: "33px", sm: "37px" } }}
						alt='avatar'
					/>
					{/* <Avatar src={avatarIcon} sx={{ width: "37px", height: "37px" }} alt='avatar' /> */}
					<div>
						<FiChevronDown size={24} style={{ color: "#999999" }} />
					</div>
					{showDropdown && (
						<div className='dropdown_menu'>
							<nav>
								<NavLink to='/profile' className='flex nav-link'>
									<AiOutlineUser size={24} color='#555' />
									Profile
								</NavLink>
								<div className='flex nav-link' onClick={logOutFunc}>
									<img className='icon' src={logOutIcon} alt='logout icon' />
									Logout
								</div>
							</nav>
						</div>
					)}
				</div>
			</section>

			<Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={showDropdown}
				onClick={() => setShowDropdown(!showDropdown)}></Backdrop>
		</NavbarWrapper>
	);
}

export default Navbar;
